import { createEffect, createEvent, restore, sample } from 'effector';
import $$app from 'models/app';
import $$dashboard from 'models/dashboard';
import $$ep from 'models/ep';
import { $isDashboard, $queryParams, setByKey } from 'models/location';
import { navigateFx } from 'models/router-gate';
import { $global } from 'models/store-global';

import DashboardService from 'services/DashboardService';
import { opposite } from 'utils/common-helper';
import delay from 'utils/factories/delay';

const resetInitialProduct = createEvent();

$$dashboard.$initialProduct.reset(delay({ source: resetInitialProduct, timeout: 100 }));

sample({
    source: $queryParams.map((params) => params['initial-product']),
    target: $$dashboard.$initialProduct,
});

// When "link-idvisor-id" is present in query parametes, then set "intial-product" to "ep"
const queryParametersThatRequireEP = ['link-advisor-id', 'link-advisor', 'product-choice', 'employer'];
sample({
    source: {
        needToAdd: $queryParams.map((params) => queryParametersThatRequireEP.some((key) => Boolean(params[key]))),
        getIsOpened: restore($$app.appLoaded.map(Boolean).map(opposite), false),
        isAlreadySet: $queryParams.map((params) => Boolean(params['initial-product'])),
    },
    filter: ({ needToAdd, getIsOpened, isAlreadySet }) => !!needToAdd && !!getIsOpened && !isAlreadySet,
    fn: () => ({ key: 'initial-product', value: 'ep' }),
    target: setByKey,
});

sample({
    source: {
        epExists: $$ep.stores.$epQInstance.map(Boolean),
        isDashboard: $isDashboard,
        initialProduct: $$dashboard.$initialProduct,
        epLoaded: $global.map((state) => state?.temp?.estatePlanLoaded || false),
    },
    filter: ({ epExists, isDashboard, initialProduct, epLoaded }) =>
        epLoaded && !epExists && isDashboard && initialProduct === 'ep',
    fn: () => false,
    target: [createEffect(DashboardService.startAssessment), resetInitialProduct],
});

sample({
    source: {
        isDashboard: $isDashboard,
        initialProduct: $$dashboard.$initialProduct,
        epLoaded: $global.map((state) => state?.temp?.estatePlanLoaded || false),
    },
    filter: ({ isDashboard, initialProduct, epLoaded }) => epLoaded && isDashboard && initialProduct === 'gift-trust',
    fn: () => '/dashboard/gift-trust',
    target: [navigateFx, resetInitialProduct],
});
